import React from 'react';
import './Dashboard.css';
import AnalyticsChart from './AnalyticsChart';

function Dashboard({ analyticsData, loading, compareMode, onReconnect }) {
  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading analytics data...</p>
        </div>
      </div>
    );
  }

  if (analyticsData.length === 0) {
    return (
      <div className="dashboard-container">
        <div className="empty-state">
          <h2>No Google Analytics accounts connected</h2>
          <p>Click "Connect Google Analytics" to add your first account</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="charts-grid">
        {analyticsData.map((account) => (
          <AnalyticsChart
            key={account._id || `${account.accountId}-${account.propertyId}`}
            accountData={account}
            compareMode={compareMode}
            onReconnect={onReconnect}
          />
        ))}
      </div>
    </div>
  );
}

export default Dashboard;
